import { defineStore } from 'pinia'
import { i18n } from '../localization'

export type NotificationType = 'Success' | 'Error' | 'Warning'

export interface Notification {
    id: number
    type: NotificationType
    title: string
    message: string
}

export interface NotificationStore {
    notifications: Notification[]
}

export const useNotificationState = defineStore('notifications', {
    state: (): NotificationStore => {
        return {
            notifications: [],
        }
    },
    actions: {
        addNotification(type: NotificationType, title: string, message?: string): void {
            const id = Math.random() * Date.now()

            this.notifications.push({
                id: id,
                type: type,
                title: title,
                message: message,
            })

            setTimeout(() => {
                this.removeNotification(id)
            }, 10000)
        },
        removeNotification(id: number) {
            this.notifications = this.notifications.filter(function (item) {
                return item.id !== id
            })
        },
    },
})

export function notify(type: NotificationType, title: string, message?: string): void {
    const store = useNotificationState()
    return store.addNotification(type, title, message)
}

export function notifySuccess(message?: string): void {
    const store = useNotificationState()
    return store.addNotification('Success', i18n.global.t('success'), message)
}
export function notifyError(message?: string): void {
    const store = useNotificationState()
    return store.addNotification('Error', i18n.global.t('error'), message)
}
